module.exports = __webpack_public_path__ + "static/box-open-c3569dab38f78666ef5148933770d5cf.png";